import Vue from "vue";
import Mudal from "./Mudal";

import { merge } from "@/utils/helpers";
import {
  use,
  registerComponent,
  registerComponentProgrammatic,
} from "@/utils/plugins";

const MudalProgrammatic = {
  open(params) {
    let parent;
    if (typeof params === "string") {
      params = {
        content: params,
      };
    }

    const defaultParam = {
      programmatic: true,
    };

    if (params.parent) {
      parent = params.parent;
      delete params.parent;
    }
    // const propsData = Object.assign(defaultParam, params);
    const propsData = merge(defaultParam, params);

    const vm = typeof window !== "undefined" && window.Vue ? window.Vue : Vue;
    const MudalComponent = vm.extend(Mudal);
    return new MudalComponent({
      parent,
      el: document.createElement("div"),
      propsData,
    });
  },
};

const Plugin = {
  install(Vue) {
    registerComponent(Vue, Mudal);
    registerComponentProgrammatic(Vue, "mudal", MudalProgrammatic);
  },
};

use(Plugin);

export default Plugin;

export { MudalProgrammatic };
